import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

// @ts-ignore
const MuiTimelineDot: Components<Theme>["MuiTimelineDot"] = {
	/** **************************************
	 * STYLE
	 *************************************** */
	styleOverrides: { root: { boxShadow: "none" } },
};

// @ts-ignore
const MuiTimelineConnector: Components<Theme>["MuiTimelineConnector"] = {
	/** **************************************
	 * STYLE
	 *************************************** */
	// @ts-ignore
	styleOverrides: {
		root: ({ theme }) => ({ backgroundColor: theme.vars.palette.divider }),
	},
};

// ----------------------------------------------------------------------

export const timeline = { MuiTimelineDot, MuiTimelineConnector };
